// 通用工具函数库

/**
 * 验证邮箱格式
 */
export function validateEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

/**
 * 验证密码强度
 */
export function validatePassword(password: string): {
  isValid: boolean
  message: string
  strength: number
} {
  let strength = 0
  let message = ''

  if (password.length >= 8) strength++
  if (/[a-z]/.test(password)) strength++
  if (/[A-Z]/.test(password)) strength++
  if (/[0-9]/.test(password)) strength++
  if (/[^A-Za-z0-9]/.test(password)) strength++

  return {
    isValid: strength >= 3,
    message,
    strength
  }
}

/**
 * 验证平台链接格式（基础校验，不做平台域名硬编码）
 * - 允许未填写（由业务层决定是否必填）
 * - 仅接受 http/https 的完整 URL
 */
export function validatePlatformUrl(url: string, _platform?: string): boolean {
  if (!url) return true
  const trimmed = url.trim()
  if (!trimmed) return true
  try {
    const parsed = new URL(trimmed)
    return parsed.protocol === 'http:' || parsed.protocol === 'https:'
  } catch {
    return false
  }
}

/**
 * 银行卡账户脱敏（显示前4位和后4位）
 */
export function maskBankAccount(accountNumber: string): string {
  if (!accountNumber || accountNumber.length < 8) {
    return accountNumber;
  }
  const cleaned = accountNumber.replace(/\s/g, '');
  if (cleaned.length < 8) {
    return accountNumber;
  }
  // 前4位 + **** **** + 后4位
  const prefix = cleaned.slice(0, 4);
  const suffix = cleaned.slice(-4);
  return `${prefix} **** **** ${suffix}`;
}

/**
 * 支付宝账户脱敏（手机号或邮箱）
 */
export function maskAlipayAccount(accountNumber: string): string {
  if (!accountNumber) {
    return accountNumber;
  }
  const trimmed = accountNumber.trim();
  
  // 手机号：11位数字
  if (/^\d{11}$/.test(trimmed)) {
    // 前3位 + **** + 后4位
    return `${trimmed.slice(0, 3)} **** ${trimmed.slice(-4)}`;
  }
  
  // 邮箱
  if (trimmed.includes('@')) {
    const [localPart, domain] = trimmed.split('@');
    const prefix = localPart.length >= 2 ? localPart.slice(0, 2) : localPart.slice(0, 1);
    return `${prefix} ****@${domain}`;
  }
  
  return accountNumber;
}

 